import React from 'react';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { ElevesDashboardProf } from 'types/classe/maClasse';
import { EleveCompetences } from 'views/EspaceProf/tabs/CompetencesTab';
import { MobileTabLineBox } from 'components/atoms/Texts/MobileTabLineBox';
import { mesComptencesFields } from 'domain/note/mesCompetences';
import { Competence } from 'types/note/note.def';

export interface TableMyResultContentProps {
  eleves: ElevesDashboardProf[];
}

export const MobileTabLineCompetences = ({
  eleves
}: TableMyResultContentProps) => {
  const eleveCompetences: EleveCompetences[] = eleves.map(eleve => {
    if (!eleve.note) return null;
    return {
      firstname: eleve.firstname,
      lastname: eleve.lastname,
      competences: mesComptencesFields(eleve.note)
    };
  });
  if (!eleveCompetences.length) return null;
  return (
    <>
      {eleveCompetences.length !== 0 &&
        eleveCompetences.map((el, i) => {
          if (el && !el.competences) return null;
          const competencesTexts = el.competences.map(
            (competence: Competence, i) => ({
              text: competence.niveau + ' / 4 | ' + competence.type
            })
          );
          return (
            <FeatureContainer key={i} padding="mobileTab">
              <MobileTabLineBox
                texts={[
                  { text: el.lastname, style: 'bold' },
                  { text: el.firstname, style: 'bold' }
                ]}
              />
              <MobileTabLineBox texts={competencesTexts} />
            </FeatureContainer>
          );
        })}
    </>
  );
};
